export const screenConstants = {
  UPDATE_COLUMNS_ORDER: "UPDATE_COLUMNS_ORDER",
  UPDATE_COLUMNS_DISPLAY: "UPDATE_COLUMNS_DISPLAY",
  GET_PREFERENCES: "GET_PREFERENCES",
  GET_COLUMNS: "GET_COLUMNS",
  CLEAR_COLUMNS : "CLEAR_COLUMNS"
};
